import React from 'react'

const LoadingSpinner = ({ size = 16 }) => (
    <div style={{
        width: `${size}px`,
        height: `${size}px`,
        border: '2px solid var(--light-gray)',
        borderTop: '2px solid var(--primary-orange)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        flexShrink: 0
    }} />
)

export default LoadingSpinner
